import {
  ActivityFormSchema,
  AgentFormSchema,
  ClientFormSchema,
  HotelFormSchema,
  InvoiceFormSchema,
  LocationFormSchema,
PackageAccommodationFormSchema,
  PackageActivityFormSchema,
  PackageFormSchema,
  PackageTransportFormSchema,
  PaymentFormSchema,
  PersonFormSchema,
  QuotationFormSchema,
  QuoteAccommodationFormSchema,
  QuoteActivityFormSchema,
QuoteTransportChildrenFormSchema,
  QuoteTransportFormSchema,
  RatePerPaxFormSchema,
  RoleFormSchema,
  RoomTypeFormSchema,
StatusFormSchema,
  TenantFormSchema,
  TransportTypeFormSchema,
  TravelVoucherFormSchema,
  UtilActivityTypeFormSchema,
UtilAgeBracketFormSchema,
  UtilTransportLocationFormSchema,
// DEFAULT IMPORT ADD
} from "./form.rule";

export const loginFormDefault = {
  username: "",
  password: "",
};
export const tenantFormDefault = {
  owner: "",
  businessName: "",
  businessType: "",
  description: "",
  avatar: "",
  email: "",
  mobileNumber: "",
  phoneNumber: "",
  website: "",
  membershipDate: "" as any,
  rewardsType: "",
  slug: "",
  postRegistrationLink: "",
} as TenantFormSchema;
export const roleFormDefault = {
  name: "",
  description: "",
} as RoleFormSchema;
export const personFormDefault = {
  tenant: "",
  role: "",
  firstName: "",
  middleName: "",
  lastName: "",
  username: "",
  email: "",
  password: "",
  isVerified: false,
  avatar: "",
  activationCode: "",
  gender: "",
  birthday: "" as any,
  isBlocked: false,
  mobileNumber: "",
  fatherName: "",
  motherName: "",
  emergencyContact_1Number: "",
  emergencyContact_1Name: "",
  emergencyContact_1Relationship: "",
  emergencyContact_2Number: "",
  emergencyContact_2Name: "",
  emergencyContact_2Relationship: "",
  sss: "",
  philhealth: "",
  pagibig: "",
  tin: "",
  medicalCondition: "",
  bloodType: "",
  elementary: "",
  highSchool: "",
  college: "",
  postCollege: "",
  undergraduate: "",
  curriculumVitae: "",
  supportingDoc: "",
  intentLetter: "",
  applicationLetter: "",
  photo: undefined,
} as PersonFormSchema;
export const transportTypeFormDefault = {
  name: "",
  description: "",
} as TransportTypeFormSchema;
export const utilTransportLocationFormDefault = {
  name: "",
  description: "",
} as UtilTransportLocationFormSchema;
export const utilActivityTypeFormDefault = {
  name: "",
  description: "",
} as UtilActivityTypeFormSchema;
export const locationFormDefault = {
  name: "",
  description: "",
} as LocationFormSchema;
export const clientFormDefault = {
  name: "",
  email: "",
  address: "",
  city: "",
  province: "",
  contactNumber: "",
} as ClientFormSchema;
export const agentFormDefault = {
  code: "",
  name: "",
  email: "",
  address: "",
  contactNumber: "",
  markupPercentage: 0,
} as AgentFormSchema;
export const hotelFormDefault = {
  // roomType: "",
  name: "",
  withBreakfast: false,
  location: "",
  description: "",
} as HotelFormSchema;
export const roomTypeFormDefault = {
  hotel: "",
  validFrom: "",
  validUntil: "",
  name: "",
  price: 0,
} as RoomTypeFormSchema;
export const activityFormDefault = {
  location: "",
  activityType: "",
  name: "",
  description: "",
  isChildActivity: false,
  childRate: 0,
  showAsOptional: false,
  isFree: false,
  entranceFee: 0,
} as ActivityFormSchema;
export const packageFormDefault = {
  name: "",
  numPeople: 0,
  unit: "",
  sizeDescription: "",
} as PackageFormSchema;
export const quotationFormDefault = {
  basePackage: "",
  basePackageName: "",
  packageName: "",
  client: "",
  clientName: "",
  status: "",
  statusName: "",
  packageInclusions: [],
  quotationDate: "",
  location: "",
  locationName: "",
  startDate: "",
  endDate: "",
  numAdults: 0,
  numChildren: 0,
  numNights: 0,
  numDays: 0,
  agent: "",
  agentMarkup: 0,
  adultRateTotal: 0,
  childRateTotal: 0,
  amount: 0,
  activities: [],
  transport: [],
  accommodation: [],
  hideTotal: false,
  customRows: [],
  customDays: [],
} as QuotationFormSchema;
export const ratePerPaxFormDefault = {
  activity: "",
  number: 0,
  childRate: 0,
  // seniorRate: 0,
  sizeDescription: "",
  amount: 0,
  totalAmount: 0,
} as RatePerPaxFormSchema;
export const packageActivityFormDefault = {
  package: "",
  activity: "",
} as PackageActivityFormSchema;
export const quoteActivityFormDefault = {
  baseActivity: "",
  quotation: "",
  isModified: false,
  name: "",
  description: "",
  day: 0,
  isChildActivity: false,
  childRate: 0,
  showAsOptional: false,
  isFree: false,
  entranceFee: 0,
  numPeople: 0,
  unit: "",
  ratePerPax: "",
  amount: 0,
} as QuoteActivityFormSchema;
export const quoteTransportFormDefault = {
  description: "",
  quotation: "",
  transportType: "",
  fromLocation: "",
  toLocation: "",
  pricePerPax: 0,
  numPeople: 0,
  unit: "",
  amount: 0,
  childrenTotal: 0,
  childPrices: [],
} as QuoteTransportFormSchema;
export const quoteAccommodationFormDefault = {
  description: "",
  night: 0,
  quotation: "",
  hotel: "",
  roomType: "",
  numPeople: 0,
  unit: "",
  validFrom: "",
  validUntil: "",
  name: "",
  price: 0,
  withBreakfast: false, // Not used in submission but needed for UI
} as QuoteAccommodationFormSchema;
export const invoiceFormDefault = {
  baseQuote: "",
  invoiceDate: "",
  dueDate: "",
  amount: 0,
} as InvoiceFormSchema;
export const travelVoucherFormDefault = {
  baseInvoice: "",
  confirmationNum: "",
  paymentCompletion: 0,
  isFullyPaid: false,
  amountPaid: 0,
  amount: 0,
} as TravelVoucherFormSchema;
export const paymentFormDefault = {
  voucher: "",
  description: "",
  paymentType: "",
  paymentDate: "" as any,
  amount: 0,
} as PaymentFormSchema;
export const packageTransportFormDefault = {
  package: "",
  transport: "",
  transportType: "",
  fromLocation: "",
  toLocation: "",
  pricePerPax: 0,
  numPeople: 0,
  unit: "",
  amount: 0,
  description: "",
} as PackageTransportFormSchema;
export const packageAccommodationFormDefault = {
  package: "",
  night: 0,
  hotel: "",
  roomType: "",
  numPeople: 0,
  unit: "",
  validFrom: "",
  validUntil: "",
  name: "",
  price: 0,
  description: "",
} as PackageAccommodationFormSchema;
export const statusFormDefault = {
  name: "",
  description: "",
} as StatusFormSchema;
export const utilAgeBracketFormDefault = {
  type: "",
  name: "",
  price: 0,
} as UtilAgeBracketFormSchema;
export const quoteTransportChildrenFormDefault = {
  quotation: "",
  quoteTransport: "",
  ageBracket: "",
  childPricePerPax: 0,
  numChildren: 0,
  amount: 0,
} as QuoteTransportChildrenFormSchema
// DEFAULT ADD
